import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EFPicture from '@elem/ui/ef-picture';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EFAirConditioner from 'elem/ui-assets/icons/appliances/EFAirConditioner';
import EFCamera from 'elem/ui-assets/icons/appliances/EFCamera';
import EFCoffeeMaker from 'elem/ui-assets/icons/appliances/EFCoffeeMaker';
import EFDrone from 'elem/ui-assets/icons/appliances/EFDrone';
import EFElectricGrill from 'elem/ui-assets/icons/appliances/EFElectricGrill';
import EFFan from 'elem/ui-assets/icons/appliances/EFFan';
import EFLaptop from 'elem/ui-assets/icons/appliances/EFLaptop';
import EFLight from 'elem/ui-assets/icons/appliances/EFLight';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import EFTV from 'elem/ui-assets/icons/appliances/EFTV';
import EFWiFi from 'elem/ui-assets/icons/appliances/EFWiFi';
import EFXBoost from 'elem/ui-assets/icons/unregular/EFXBoost';
import { useRouter } from 'next/router';
import { useState } from 'react';
import imgLocale1 from './imgs/imgLocale1';
import imgLocale2 from './imgs/imgLocale2';
import imgLocale3 from './imgs/imgLocale3';
import imgLocale4 from './imgs/imgLocale4';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();
    const [active, setActive] = useState(0);
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);

    const img1 = imgLocale1[locale] || imgLocale1['us'];
    const img2 = imgLocale2[locale] || imgLocale2['us'];
    const img3 = imgLocale3[locale] || imgLocale3['us'];
    const img4 = imgLocale4[locale] || imgLocale4['us'];
    const items = [
        {
            pc: img1.pc,
            h5: img1.h5,
            tab: t('F_tab1'),
            apps: [
                {
                    icon: IS_EU_SITES ? <EFAirConditioner /> : <EFRefrigerator />,
                    appName: t('F_tab1_app1_name'),
                    appTime: t('F_tab1_app1_time'),
                },
                {
                    icon: IS_EU_SITES ? <EFElectricGrill /> : <EFTV />,
                    appName: t('F_tab1_app2_name'),
                    appTime: t('F_tab1_app2_time'),
                },
                {
                    icon: IS_EU_SITES ? <EFCoffeeMaker /> : <EFWiFi />,
                    appName: t('F_tab1_app3_name'),
                    appTime: t('F_tab1_app3_time'),
                },
            ],
        },
        {
            pc: img2.pc,
            h5: img2.h5,
            tab: t('F_tab2'),
            apps: [
                {
                    icon: IS_EU_SITES ? <EFRefrigerator /> : <EFLight />,
                    appName: t('F_tab2_app1_name'),
                    appTime: t('F_tab2_app1_time'),
                },
                {
                    icon: IS_EU_SITES ? <EFTV /> : <EFPhone />,
                    appName: t('F_tab2_app2_name'),
                    appTime: t('F_tab2_app2_time'),
                },
                {
                    icon: IS_EU_SITES ? <EFWiFi /> : <EFFan />,
                    app: t('F_tab2_app3'),
                    appName: t('F_tab2_app3_name'),
                    appTime: t('F_tab2_app3_time'),
                },
            ],
        },
        {
            pc: img3.pc,
            h5: img3.h5,
            tab: t('F_tab3'),
            apps: [
                {
                    icon: IS_EU_SITES ? <EFLight /> : <EFAirConditioner />,
                    appName: t('F_tab3_app1_name'),
                    appTime: t('F_tab3_app1_time'),
                },
                {
                    icon: IS_EU_SITES ? <EFPhone /> : <EFElectricGrill />,
                    appName: t('F_tab3_app2_name'),
                    appTime: t('F_tab3_app2_time'),
                },
                {
                    icon: IS_EU_SITES ? <EFFan /> : <EFCoffeeMaker />,
                    appName: t('F_tab3_app3_name'),
                    appTime: t('F_tab3_app3_time'),
                },
            ],
        },
        {
            pc: img4.pc,
            h5: img4.h5,
            tab: t('F_tab4'),
            apps: [
                {
                    icon: IS_EU_SITES ? <EFCamera /> : <EFDrone />,
                    appName: t('F_tab4_app1_name'),
                    appTime: t('F_tab4_app1_time'),
                },
                {
                    icon: IS_EU_SITES ? <EFLaptop /> : <EFCamera />,
                    appName: t('F_tab4_app2_name'),
                    appTime: t('F_tab4_app2_time'),
                },
                {
                    icon: IS_EU_SITES ? <EFDrone /> : <EFLaptop />,
                    appName: t('F_tab4_app3_name'),
                    appTime: t('F_tab4_app3_time'),
                },
            ],
        },
    ];

    const handleClickTab = (k: number) => {
        setActive(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('F_title') || t('F_desc'),
            button_name: items[k].tab,
        });
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-m" />
            {(IS_NA_SITES || IS_EU_SITES) && (
                <>
                    <div className="x-boost">
                        <EFXBoost />
                    </div>
                    {IS_NA_SITES && <EfTitle>{t('F_title')}</EfTitle>}
                </>
            )}
            <p className="text">{t('F_desc')}</p>
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li className={`item${active === k ? ' active' : ''}`} key={k}>
                        <div className="item-img">
                            <EFPicture src={item?.pc} srcPad={item?.h5 || item?.pc} alt={item.tab} />
                        </div>
                        <ul className="apps">
                            {item?.apps?.map((app: any, m: number) => (
                                <li className="app" key={`${k}_${m}`}>
                                    {app.icon}
                                    <div className="app-info">
                                        <p className="app-text app-name">{app.appName}</p>
                                        <p className="app-text app-time">{app.appTime}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
            <div className="tabs-box">
                <ul className="tabs">
                    {items?.map((tab: any, k: number) => (
                        <li className={`tab${active === k ? ' active' : ''}`} key={k} onClick={() => handleClickTab(k)}>
                            {tab.tab}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
